import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Query} from 'react-apollo'
import {GET_PERSON} from './mutations'
import BlockWithLoader from '../Support/BlockWithLoader'
import Form from './Form'
import {CardHeader, Button} from 'reactstrap'
import {Link} from 'react-router-dom'

class Person extends Component {
  render() {
    return (
      <Query query={GET_PERSON} variables={{id: this.props.match.params.id}}>
        {({data, loading, error}) => {
          if (error) return <div>An unexpected error occurred</div>

          return (
            <BlockWithLoader loading={loading} renderChildren={true}>
              <CardHeader>
                <b>Person id: {this.props.match.params.id}</b>
                {!loading && <Link className='float-right' role='button' to={`/welders?uuid=${data.person.uuid}`} target='_blank'>
                  <Button size='sm' color='primary'>Their certificates</Button>
                </Link>}
              </CardHeader>
              {!loading &&
              <Form
                editData={data.person}
                onClose={() => this.props.history.goBack() || this.props.history.push('/people')}
                afterSubmit={() => this.props.history.goBack() || this.props.history.push('/people')}
                permissionGroupsData={data.groups}
                companiesData={data.companies.list}
              />}
            </BlockWithLoader>
          )
        }}
      </Query>
    )
  }
}

Person.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}

export default Person



// WEBPACK FOOTER //
// ./src/components/People/Person.js